import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { MatTabsModule } from '@angular/material/tabs';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { GtwDirectivesModule } from '../shared/_directives/gtw-directives.module';
import { ReleaseNotesComponent } from './release-notes.component';
import { FormsModule } from '@angular/forms';
import { AppNgAppkitModule } from '../app-ng-appkit.module';
import { SharedPipesModule } from '../shared/pipes/shared-pipe.module';

@NgModule({
  declarations: [ReleaseNotesComponent],
  imports: [
    CommonModule,
    MatTabsModule,
    MatIconModule,
    MatMenuModule,
    GtwDirectivesModule,
    AppNgAppkitModule,
    FormsModule,
    SharedPipesModule,
  ],
  providers: [],
  exports: [ReleaseNotesComponent],
})
export class ReleaseModule {}
